import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Link,
  RadioGroup,
  FormControlLabel,
  Radio,
  Snackbar,
} from '@material-ui/core';
import { DEPARTMENT_ADMIN } from '../../../../constants/departmentConstants';
import { Alert } from '@material-ui/lab';
import 'suneditor/dist/css/suneditor.min.css';
import MaterialTable from 'material-table';
import { useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Formik, Form, Field, FastField } from 'formik';
import { object, string, date, number } from 'yup';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import clsx from 'clsx';
import Moment from 'react-moment';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { showErrIfTouched, filterDate } from '../../../../utils';
import Dropzone from '../../../../components/MultipleDrop';
import useStyles from '../../Main.style';
import useDashboard from '../../../../hooks/useDashboard';
import useQuickBook from '../../../../hooks/useQuickBook';
import useCalendarEvents from '../../../../hooks/useCalendarEvents';
import useAnnouncements from '../../../../hooks/useAnnouncements';
import usePractice from '../../../../hooks/usePractice';
import useLearningOpportunity from '../../../../hooks/useLearningOpportunity';
import CalendarDashBoardView from '../../CalendarNotification/CalendarDashboardView/CalendarDashboardView';
import EditOptions from '../../../../components/EditOptions';
import MyPersonalPerformance from '../MyPersonalPerformance/MyPersonalPerformance';
import SummaryInvoiceByCountry from '../SummaryInvoiceByCountry/SummaryInvoiceByCountry';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import QbFieldsByCountry from '../QbFieldsByCountry/QbFieldsByCountry';
import WelcomeModal from '../WelcomeModal';
import DashboardGoals from '../DashboardGoals/DashboardGoals';
import {
  DELETE_LEARNING_OPP_WARNING,
  DELETE_ANNOUCEMENT_WARNING,
  DELETE_GLOBAL_GIVING_CAUSE,
} from '../../../../constants/deleteMessaageConstants';
import DeleteOption from '../../../../components/DeleteOption';
import {
  setDepartmentName,
  getLoggedInUserData,
  formatToCurrency,
  formatToNumber,
  customSortHelper,
} from '../../../../utils/Helper';

const SummaryTab = React.memo(function SummaryTab() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const loggedInUserData = getLoggedInUserData();
  const userId = loggedInUserData?.id;
  const departmentId = loggedInUserData?.departmentId;
  const cellId = loggedInUserData?.cellId;
  const defaultState = 'changeInStatus';
  let calendarEventsData = {};
  const [financialPerformanceCountryByYear, setFinancialPerformanceCountryByYear] = React.useState(
    [],
  );
  const [cellList, setCellList] = useState([]);
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [globalGivingCountryList, setGlobalGivingCountryList] = useState([]);
  const [announcementId, setAnnouncementId] = useState();
  const [loggedInUserDetails, setLoggedInUserDetails] = useState([]);
  const [recentAnnouncementsList, setRecentAnnouncementsList] = useState([]);
  const [recentGlobalGivingCauses, setRecentGlobalGivingCauses] = useState([]);
  const [recentLearningOpportunities, setRecentLearningOpportunities] = useState([]);
  const [profitRevenueQbObj, setProfitRevenueQbObj] = React.useState([]);
  const [
    deleteLearningOpportunitiesPermission,
    setDeleteLearningOpportunitiesPermission,
  ] = useState(false);
  const [editLearningOpportunitiesPermission, setEditLearningOpportunitiesPermission] = useState(
    false,
  );
  const [statusToFetchMyCompanyPerformance, setStatusToFetchMyCompanyPerformance] = useState(
    defaultState,
  );
  const [dashboardComments, setDashboardComments] = useState([]);
  const [editData, setEditData] = React.useState(null);
  const [openLearningForm, setOpenLearningForm] = React.useState(false);
  const [openGlobalCauseDelete, setOpenGlobalCauseDelete] = React.useState(false);
  const [openEditGlobalCauseForm, setOpenEditGlobalCauseForm] = React.useState(false);
  const [globalCauseDeleteId, setGlobalCauseDeleteId] = React.useState(0);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [editGlobalCausePermission, setEditGlobalCausePermission] = useState(false);
  const [deleteGlobalCausePermission, setDeleteGlobalCausePermission] = useState(false);
  const [summaryInvoiceByCellArr, setSummaryInvoiceByCellArr] = React.useState([]);
  const [summaryInvoiceByCountryArr, setSummaryInvoiceByCountryArr] = React.useState([]);
  const [myCompanyInvoicingPerformanceData, setMyCompanyInvoicingPerformanceData] = useState([]);
  const [updateAnnouncements, setUpdateAnnouncements] = useState([]);
  const [deleteId, setDeleteId] = React.useState(0);
  const [countryFileManagementLoader, setCountryFileManagementLoader] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(null);
  const [editCauseDetails, setEditCauseDetails] = useState([]);
  const [updateAnnouncementDialog, setUpdateAnnouncementDialog] = React.useState(null);
  const [fileManagementForCompany, setFileManagementForCompany] = useState([]);
  const [showSnackBarErr, setShowSnackBarErr] = useState(false);
  const [showSnackBarMessage, setShowSnackBarMessage] = useState('');

  const typeOptions = [
    { id: 'actualStatus', title: 'Actual Status' },
    { id: 'changeInStatus', title: 'Change in Status' },
  ];

  const {
    getTotalPastDueInvoices,
    getTotalPastDueInvoicesForAllCells,
    getProfitRevenue,
  } = useQuickBook();
  const { deleteLearningOpportunity, saveLearningOpportunity } = useLearningOpportunity();
  const {
    deleteGlobalCause,
    addGlobalGivingCause,
    getFinancialPerformanceCountryByYear,
    getDashboardComments,
    fetchAllCellList,
  } = usePractice();
  const { addAnnouncement, deleteAnnouncement } = useAnnouncements();
  const {
    getRecentAnnouncements,
    getCountry,
    getMyCompanyInvoicingPerformance,
    getTotalFileListFromLogiware,
    getTotalFileListPerChangeFromLogiware,
  } = useDashboard();
  const { getCalendarEventsForWeek } = useCalendarEvents();
  const loadDashboardDetails = async () => {
    const recentAnnouncements = await getRecentAnnouncements(
      departmentId,
      cellId,
      loggedInUserData?.id,
    );
    setLoggedInUserDetails(recentAnnouncements?.usersDetails);
    setRecentAnnouncementsList(recentAnnouncements?.usersResult);
    setRecentGlobalGivingCauses(recentAnnouncements?.globalGivingCauses);
    setRecentLearningOpportunities(recentAnnouncements?.recentLearningOpportunities || []);
    setEditLearningOpportunitiesPermission(
      recentAnnouncements?.usersDetails?.permissionArray?.includes(
        recentAnnouncements.editLearningOpportunitie?.id,
      ) ?? false,
    );
    setDeleteLearningOpportunitiesPermission(
      recentAnnouncements?.usersDetails?.permissionArray?.includes(
        recentAnnouncements.removeLearningOpportunitie?.id,
      ) ?? false,
    );

    setEditGlobalCausePermission(
      recentAnnouncements?.usersDetails?.permissionArray?.includes(
        recentAnnouncements.editCause?.id,
      ) ?? false,
    );
    setDeleteGlobalCausePermission(
      recentAnnouncements?.usersDetails?.permissionArray?.includes(
        recentAnnouncements.removeCause?.id,
      ) ?? false,
    );
  };
  const deleteSelectedAnnouncement = async () => {
    await deleteAnnouncement(announcementId);
    setShowSnackBarMessage('Announcement Deleted Successfully');
    setShowSnackBarErr(true);
    setOpenDeleteDialog(false);
    loadDashboardDetails();
  };

  const loadAllCells = async () => {
    const allCellList = await fetchAllCellList({ countryId: loggedInUserData?.countryId });
    setCellList(allCellList?.usersResult);
    setCellListForFilter(allCellList?.usersResult);
  };
  const loadCells = async (countryId) => {
    let cellListCopy = cellListForFilter;
    cellListCopy = cellListCopy.filter((cell) => cell?.countryId === countryId);
    setCellList(cellListCopy);
    return cellListCopy;
  };
  async function findParentObjectBySearchText(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (const item of obj) {
          const result = await findParentObjectBySearchText(item, searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (const prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            const result = await findParentObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }

  const loadProfitQb = async () => {
    let revenueValue = 0;
    let grossProftYtdValue = 0;
    let operationProfitYtdValue = 0;
    let revenuePrevYearValue = 0;
    let profitValue = 0;
    let profitPrevYearValue = 0;
    let netIncomeYtdValue = 0;
    let imcomeTaxesYtdValue = 0;

    const resultData = await getProfitRevenue();
    if (resultData) {
      revenueValue = await findParentObjectBySearchText(
        resultData?.reportResultYtd,
        'Total Income', //Current Year YTD
      );
      grossProftYtdValue = await findParentObjectBySearchText(
        resultData?.reportResultYtd,
        'Gross Profit', ////Current Year YTD
      );

      operationProfitYtdValue = await findParentObjectBySearchText(
        resultData?.reportResultYtd,
        'Net Operating Income', ////Current Year YTD
      );

      netIncomeYtdValue = await findParentObjectBySearchText(
        resultData?.reportResultYtd,
        'Net Income', ////Current Year YTD
      );
      imcomeTaxesYtdValue = await findParentObjectBySearchText(
        resultData?.reportResultYtd,
        'Income Taxes', ////Current Year YTD
      );
      revenuePrevYearValue = await findParentObjectBySearchText(
        resultData?.reportResultPrevYear,
        'Total Income', //Last Year
      );
      profitValue = await findParentObjectBySearchText(resultData?.reportResultYtd, 'Net Income');

      profitPrevYearValue = await findParentObjectBySearchText(
        resultData?.reportResultPrevYear,
        'Net Income', //Last Year
      );

      setProfitRevenueQbObj({
        revenueValue: revenueValue?.parent[1]?.value,
        grossProftYtdValue: grossProftYtdValue?.parent[1]?.value,
        operationProfitYtdValue: operationProfitYtdValue?.parent[1]?.value,
        netIncomeYtdValue: netIncomeYtdValue?.parent[1]?.value,
        imcomeTaxesYtdValue: imcomeTaxesYtdValue?.parent[1]?.value,
        revenuePrevYearValue: revenuePrevYearValue?.parent[1]?.value,
        profitValue: profitValue?.parent[1]?.value,
        profitPrevYearValue: profitPrevYearValue?.parent[1]?.value,
      });
    }
  };

  const handleSnackBarClose = () => {
    setShowSnackBarErr(false);
  };

  const loadPastDueInvoicesByCell = async () => {
    const pastDueInvoicesArr = await getTotalPastDueInvoicesForAllCells();
    setSummaryInvoiceByCellArr(pastDueInvoicesArr?.reportResult || []);
  };
  const handleClose = () => {
    setOpenDelete(false);
    setOpenDeleteDialog(false);
    setOpenLearningForm(false);
    setUpdateAnnouncementDialog(false);
    setOpenGlobalCauseDelete(false);
    setOpenEditGlobalCauseForm(false);
  };

  const handleClickDelete = (val) => {
    setDeleteId(val);
    setOpenDelete(true);
  };

  const handleClickOnDeleteGlobalCause = (val) => {
    setGlobalCauseDeleteId(val);
    setOpenGlobalCauseDelete(true);
  };

  const deleteGlobalGivingCause = async () => {
    await deleteGlobalCause(globalCauseDeleteId);
    setShowSnackBarMessage('Global Giving Cause Deleted Successfully');
    setShowSnackBarErr(true);
    setOpenGlobalCauseDelete(false);
    loadDashboardDetails();
  };
  const handleOnDeleteClick = async () => {
    await deleteLearningOpportunity({ id: deleteId });
    setShowSnackBarMessage('Learning Opportunity Deleted Successfully');
    setShowSnackBarErr(true);
    setOpenDelete(false);
    loadDashboardDetails();
  };
  const handleClickOpenUpdateBox = async (val) => {
    let AnnouncementsCopy = recentAnnouncementsList;
    const result = await AnnouncementsCopy.find((announcement) => announcement?.id === val);
    let data = {
      id: result?.id,
      title: result?.title,
      description: result?.description,
      expirationDate: result?.expirationDate,
    };
    setAnnouncementId(val);
    setUpdateAnnouncements(data);
    setUpdateAnnouncementDialog(true);
  };
  const handleClickDeleteAnnnouncementMenu = (val) => {
    setAnnouncementId(val);
    setOpenDeleteDialog(true);
  };
  const handleEditClickOpen = async (menuData) => {
    const data = {
      id: menuData?.id,
      type: menuData?.type,
      whatHappened: menuData?.whatHappened,
      learned: menuData?.learned,
      eventDate: menuData?.eventDate,
    };
    if (menuData?.type === '2') {
      data.cost = menuData?.learningOpportunityMistake?.cost;
      data.doneDifferently = menuData?.learningOpportunityMistake?.doneDifferently;
    }
    setEditData(data);
    setOpenLearningForm(true);
  };
  const SetGlobalGivingCausesSchema = object().shape({
    organizationname: string().required('Organization Name is required'),
    description: string()
      .required('Description is required')
      .max(300, 'Maximum character allowed is 300.')
      .nullable(),
    amount: number()
      .typeError("That doesn't look like Amount")
      .positive("Amount can't start with a minus")
      .integer("Amount can't include a decimal point")
      .nullable(),
    imagelink: string()
      .required('Image Link is required')
      .matches(/^(http:\/\/|https:\/\/)/, 'Please Enter Valid Link')
      .required('Please Enter Valid Link'),
  });
  const SetAddAnnouncementSchema = object().shape({
    title: string().required('Organization Name is required'),
    description: string().required('Description is required'),
    expirationDate: date('Please enter Expiration Date')
      .nullable()
      .typeError('Please enter a valid Expiration Date')
      .min(new Date(), 'Please enter a valid Expiration Date')
      .required('Expiration Date is required'),
  });

  const handleClickOnEditGlobalCause = async (val) => {
    setOpenEditGlobalCauseForm(true);
    let globalGivingListCopy = recentGlobalGivingCauses;
    const result = await globalGivingListCopy.find((globalGiving) => globalGiving?.id === val);
    let cellListCopy = cellListForFilter;
    cellListCopy = await cellListCopy.filter((cell) => cell?.countryId === result?.countryId);
    setEditCauseDetails({
      ...result,
      file: [
        {
          path: `${location.hostname === 'localhost' ? `//localhost:9001/` : `/api/`}${
            result?.images
          }`,
          name: result?.images?.replace(/^.*[\\\/]/, ''),
        },
      ],
    });
    setCellList(cellListCopy);
    return cellListCopy;
  };
  const loadFinancialPerformanceCountryByYear = async () => {
    const result = await getFinancialPerformanceCountryByYear({ year: new Date().getFullYear() });
    if (result) {
      calculateYearlyFpTotals(result?.usersResult, result?.countryList);
    }
  };

  //Company Performance File Management Table
  const loadTotalFileListFromLogiware = async (statusToFetchMyCompanyPerformance) => {
    setCountryFileManagementLoader(true);
    const userList =
      statusToFetchMyCompanyPerformance == 'actualStatus'
        ? await getTotalFileListFromLogiware()
        : await getTotalFileListPerChangeFromLogiware();
    setFileManagementForCompany(userList?.usersResult);
    setCountryFileManagementLoader(false);
  };
  const loadMyCompanyInvoicingPerformance = async () => {
    const myCompanyInvoicingPerformance = await getMyCompanyInvoicingPerformance({
      cellValue: loggedInUserData?.cell?.cellValue,
      countryTitle: loggedInUserData?.country?.countryValue,
      countryId: loggedInUserData?.countryId,
    });
    setMyCompanyInvoicingPerformanceData(
      myCompanyInvoicingPerformance?.usersResult ? myCompanyInvoicingPerformance?.usersResult : [],
    );
  };

  const loadPastDueInvoicesByCountry = async (reportDate) => {
    const countryArr = await getCountry();

    const pastDueInvoicesArr = await getTotalPastDueInvoices({
      reportDate,
      country: countryArr?.countryList?.find((c) => c.shortName?.toLowerCase() === 'us'),
      agingPeriod: '30',
    });
    setSummaryInvoiceByCountryArr({
      reportResult: pastDueInvoicesArr?.reportResult,
      country: countryArr?.countryList?.find((c) => c?.shortName?.toLowerCase() === 'us'),
    });
  };

  const loadDashboardCommentsDetails = async () => {
    const result = await getDashboardComments();
    if (result) {
      setDashboardComments(result?.usersResult);
    }
  };
  const loadCountries = async () => {
    const countryLists = await getCountry();
    setGlobalGivingCountryList(countryLists?.countryList);
  };

  const calculateYearlyFpTotals = (arr, countryListDetails) => {
    if (arr && arr?.length > 0) {
      const totalsByCountry = arr?.reduce((totals, c) => {
        const countryName =
          countryListDetails?.find((cl) => cl?.id === c?.countryId)?.shortName?.toLowerCase() ||
          countryListDetails?.find((cl) => cl?.id === c?.countryId)?.countryTitle?.toLowerCase();
        if (!totals[countryName]) {
          totals[countryName] = {
            grossProfit: null,
            incomeBeforeTaxes: null,
            netIncome: null,
            operatingIncome: null,
            revenue: null,
            taxes: null,
          };
        }

        totals[countryName] = {
          grossProfit: [totals[countryName]?.grossProfit, c?.grossProfit].every((value) => {
            return value === null;
          })
            ? null
            : totals[countryName]?.grossProfit + Number(c?.grossProfit),
          incomeBeforeTaxes: [totals[countryName]?.incomeBeforeTaxes, c?.incomeBeforeTaxes].every(
            (value) => {
              return value === null;
            },
          )
            ? null
            : totals[countryName]?.incomeBeforeTaxes + Number(c?.incomeBeforeTaxes),
          operatingIncome: [totals[countryName]?.operatingIncome, c?.operatingIncome].every(
            (value) => {
              return value === null;
            },
          )
            ? null
            : totals[countryName]?.operatingIncome + Number(c?.operatingIncome),
          revenue: [totals[countryName]?.revenue, c?.revenue].every((value) => {
            return value === null;
          })
            ? null
            : totals[countryName]?.revenue + Number(c?.revenue),
        };

        return totals;
      }, {});

      setFinancialPerformanceCountryByYear(totalsByCountry);
    }
  };

  const loadGetCalendarEventsForWeek = async () => {
    if (Object.keys(calendarEventsData).length === 0) {
      calendarEventsData = await getCalendarEventsForWeek();
    }
  };

  useEffect(() => {
    loadFinancialPerformanceCountryByYear();
  }, []);

  useEffect(() => {
    loadDashboardDetails();
    loadAllCells();
  }, []);

  useEffect(() => {
    loadGetCalendarEventsForWeek();
    loadCountries();
  }, []);
  useEffect(() => {
    const reportDatePrevYear = moment().format('YYYY-MM-DD');
    loadDashboardCommentsDetails();

    loadPastDueInvoicesByCountry(reportDatePrevYear);
    loadMyCompanyInvoicingPerformance();
    loadTotalFileListFromLogiware(statusToFetchMyCompanyPerformance);
  }, []);

  useEffect(() => {
    loadPastDueInvoicesByCell();
  }, []);

  useEffect(() => {
    loadProfitQb();
  }, []);
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} className={classes.TabBlock}>
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12}>
            <Box m={3} />
          </Grid>
        </Grid>
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12} sm={12} md={12} className={clsx(classes.innercontent)}>
            <Grid container>
              <CalendarDashBoardView
                calendarEventsData={calendarEventsData}
              ></CalendarDashBoardView>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {/* <Box m={1} /> */}
          </Grid>
        </Grid>
        <Grid container spacing={4} justifyContent="space-between">
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            className={clsx(classes.innercontent, classes.innercontentWidth)}
          >
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h5">Recent Announcements</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <If condition={recentAnnouncementsList != null}>
                      <For each="announcement" of={recentAnnouncementsList || []}>
                        <Box className={classes.innercontentWhite} mb={2}>
                          <Box display="flex" justifyContent="space-between">
                            <Box display="flex">
                              <Grid container spacing={2} direction="row" alignItems="center">
                                <Grid item align="left">
                                  <Box display="flex">
                                    <img
                                      style={{ width: '50px' }}
                                      className={classes.img}
                                      src={
                                        location.hostname === 'localhost'
                                          ? `//localhost:9001/${announcement?.createdByUserDetails?.profilePic}`
                                          : `/api/${announcement?.createdByUserDetails?.profilePic}`
                                      }
                                      alt={
                                        announcement?.createdByUserDetails?.firstName +
                                        ' ' +
                                        announcement?.createdByUserDetails?.lastName
                                      }
                                    />
                                  </Box>
                                </Grid>
                                <Grid item align="left">
                                  <Typography variant="body2" noWrap>
                                    <Moment format="MMM D[,] YYYY">
                                      {announcement?.createdAt}
                                    </Moment>
                                  </Typography>
                                  <Typography variant="h4" noWrap>
                                    {`${announcement?.createdByUserDetails?.firstName} ${announcement?.createdByUserDetails?.lastName}`}
                                  </Typography>
                                  <Typography variant="body2" noWrap>
                                    {`Leader . ${setDepartmentName(
                                      announcement?.departmentDetails?.departmentTitle,
                                      announcement?.createdByUserDetails?.roleId,
                                    )} . ${announcement?.cellDetails?.cellTitle}`}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
                            <Box>
                              <If condition={announcement?.createdByUser === userId}>
                                <Box
                                  display="flex"
                                  justifyContent="flex-end"
                                  className={classes.GlobalGivingCausesMore}
                                >
                                  <EditOptions
                                    item={announcement}
                                    _handleClose={handleClose}
                                    handleEditClickOpen={() => {
                                      handleClickOpenUpdateBox(announcement?.id);
                                    }}
                                    handleClickDelete={() => {
                                      handleClickDeleteAnnnouncementMenu(announcement?.id);
                                    }}
                                    editPermission
                                    deletePermission
                                  />
                                </Box>
                              </If>
                            </Box>
                          </Box>
                          <Box mt={1}>
                            <Box display="flex" mb={0.5}>
                              <Typography variant="h5" noWrap>
                                {announcement?.title}
                              </Typography>
                            </Box>
                            <Box display="flex">
                              <Typography
                                variant="body2"
                                style={{ wordBreak: 'break-all' }}
                                className={classes.AnnouncementText}
                              >
                                {announcement?.description}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </For>
                    </If>
                    <If condition={recentAnnouncementsList === null}>
                      <Box className={classes.innercontentWhite}>
                        <Box>
                          <Typography variant="body2">No recent announcements yet.</Typography>
                        </Box>
                      </Box>
                    </If>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  height={1}
                  mt={0.5}
                >
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Box>
                      <Link color="textPrimary" href="/#/app/announcements">
                        <Typography variant="caption">View all</Typography>
                      </Link>
                    </Box>
                    <Box className={classes.ViewAll}>
                      <ArrowForwardIcon />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Box m={1} />
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            className={clsx(classes.innercontent, classes.innercontentWidth)}
          >
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h5">Recent Learning Opportunities</Typography>
                  </Grid>
                  <If condition={recentLearningOpportunities.length > 0}>
                    <For each="item" of={recentLearningOpportunities}>
                      <Grid item xs={12}>
                        <Box className={classes.innercontentWhite}>
                          <Box display="flex" justifyContent="space-between">
                            <Box display="flex">
                              <Box>
                                <img
                                  className={classes.img}
                                  src={
                                    require(`../../../../assets/images/${
                                      item?.type === '1' ? 'Accomplishment' : 'Mistake'
                                    }.png`).default
                                  }
                                  alt="Specialty"
                                />
                              </Box>
                              <Box ml={0.5}>
                                <Typography variant="body1" noWrap>
                                  {item?.type === '1' ? 'Accomplishment' : 'Mistake'}
                                </Typography>
                              </Box>
                            </Box>
                            <Box display="flex">
                              <If
                                condition={
                                  editLearningOpportunitiesPermission === true ||
                                  deleteLearningOpportunitiesPermission === true ||
                                  (loggedInUserDetails?.department?.departmentTitle ===
                                    DEPARTMENT_ADMIN &&
                                    loggedInUserDetails?.roleId === 1)
                                }
                              >
                                <EditOptions
                                  item={item}
                                  _handleClose={handleClose}
                                  handleEditClickOpen={() => {
                                    handleEditClickOpen(item);
                                  }}
                                  handleClickDelete={() => {
                                    handleClickDelete(item.id);
                                  }}
                                  roleId={loggedInUserDetails?.roleId}
                                  departmentId={loggedInUserDetails?.department?.departmentTitle}
                                  editPermission={editLearningOpportunitiesPermission}
                                  deletePermission={deleteLearningOpportunitiesPermission}
                                />
                              </If>
                            </Box>
                          </Box>
                          <Box display="flex" justifyContent="space-between">
                            <Box display="flex" alignItems="flex-end">
                              <Box>
                                <Typography variant="h4" noWrap>
                                  {item?.user?.department?.departmentTitle}
                                </Typography>
                              </Box>
                              <Box ml={1}>
                                <Typography variant="body2" noWrap style={{ lineHeight: '18px' }}>
                                  <Moment format="MMM D[,] YYYY">{item?.createdAt}</Moment>
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                          <Box mt={1}>
                            <Box display="flex">
                              <Typography variant="h5" noWrap>
                                Event date
                              </Typography>
                            </Box>
                            <Box display="flex" whiteSpace="normal">
                              <Typography variant="body2">
                                <Moment format="MMM D[,] YYYY">{item?.eventDate}</Moment>
                              </Typography>
                            </Box>
                          </Box>
                          <Box mt={1}>
                            <Box display="flex">
                              <Typography variant="h5" noWrap>
                                What happened?
                              </Typography>
                            </Box>
                            <Box display="flex">
                              <Typography variant="body2" noWrap>
                                {item?.whatHappened || '-'}
                              </Typography>
                            </Box>
                          </Box>
                          <If condition={item?.learningOpportunityMistakeId}>
                            <Box mt={1}>
                              <Box display="flex">
                                <Typography variant="h5" noWrap>
                                  How much did it cost us?
                                </Typography>
                              </Box>
                              <Box display="flex">
                                <Typography variant="body2" noWrap>
                                  {item?.learningOpportunityMistake?.cost
                                    ? formatToCurrency(item?.learningOpportunityMistake?.cost)
                                    : '-'}
                                </Typography>
                              </Box>
                            </Box>
                            <Box mt={1}>
                              <Box display="flex">
                                <Typography variant="h5" noWrap>
                                  What could you have done differently?
                                </Typography>
                              </Box>
                              <Box display="flex" whiteSpace="normal">
                                <Typography variant="body2" style={{ wordBreak: 'break-all' }}>
                                  {item?.learningOpportunityMistake?.doneDifferently || '-'}
                                </Typography>
                              </Box>
                            </Box>
                          </If>
                          <Box mt={1}>
                            <Box display="flex">
                              <Typography variant="h5" noWrap>
                                What did you learn?
                              </Typography>
                            </Box>
                            <Box display="flex" whiteSpace="normal">
                              <Typography variant="body2" style={{ wordBreak: 'break-all' }}>
                                {item?.learned || '-'}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </For>
                  </If>
                  <If condition={recentLearningOpportunities.length === 0}>
                    <Grid item xs={12}>
                      <Box className={classes.innercontentWhite}>
                        <Box>
                          <Typography variant="body2">
                            No recent learning opportunities yet.
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </If>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  height={1}
                  mt={0.5}
                >
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Box>
                      <Link color="textPrimary" href="/#/app/learning-opportunities">
                        <Typography variant="caption">View all</Typography>
                      </Link>
                    </Box>

                    <Box className={classes.ViewAll}>
                      <ArrowForwardIcon />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* <MyGoals myProfessionalQuarterlyGoal={myProfessionalQuarterlyGoal} /> */}
        <Grid container spacing={4}>
          <DashboardGoals type={'summary'} />
        </Grid>
        <MyPersonalPerformance />
        <Grid container spacing={4}>
          <Grid item xs={12} className={classes.innercontent}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5">Company Performance</Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <SummaryInvoiceByCountry
                      reportArr={summaryInvoiceByCountryArr}
                      myCountryInvoiceArray={myCompanyInvoicingPerformanceData}
                      myProfitRevenue={profitRevenueQbObj}
                      financialPerformanceCountryByYear={financialPerformanceCountryByYear}
                      dashboardComments={dashboardComments}
                      dashboardSectionText="Company Performance"
                      onCommentUpdate={loadDashboardCommentsDetails}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <Box className={classes.innercontentWhite} height="100%">
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        flexDirection={{ xs: 'column', sm: 'row' }}
                      >
                        <Box mb={{ xs: 2, sm: 0 }}>
                          <Typography variant="h5" noWrap>
                            File Management
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: 200,
                            border: '1px solid #003C6F',
                            borderRadius: '4px',
                            marginTop: '-8px',
                          }}
                          mb={{ xs: 1, sm: 0 }}
                        >
                          <Autocomplete
                            id="type"
                            options={typeOptions}
                            disablePortal
                            getOptionLabel={(option) => option?.title}
                            getOptionSelected={(option, value) => option?.id === value?.id}
                            value={
                              statusToFetchMyCompanyPerformance
                                ? typeOptions.find(
                                    (d) => d?.id === statusToFetchMyCompanyPerformance,
                                  )
                                : null
                            }
                            onChange={(e, value) => {
                              setStatusToFetchMyCompanyPerformance(
                                value?.id ? value?.id : defaultState,
                              );
                              loadTotalFileListFromLogiware(value?.id ? value?.id : defaultState);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Type" name="type" variant="outlined" />
                            )}
                            popupIcon={<ExpandMoreIcon />}
                          />
                        </Box>
                        <InfoPopover
                          dashboardComments={dashboardComments}
                          dashboardSectionText="Company Performance File Management"
                          onCommentUpdate={loadDashboardCommentsDetails}
                        />
                      </Box>
                      <Box mt={1} className={classes.TableUIV2}>
                        <MaterialTable
                          style={{ boxShadow: 'none' }}
                          isLoading={countryFileManagementLoader}
                          options={{
                            toolbar: false,
                            draggable: false,
                            paging: false,
                            sorting: true,
                            pageSize: 20,
                            pageSizeOptions: [10, 20, 50, 100],
                            showTextRowsSelected: false,
                            toolbarButtonAlignment: 'right',
                            showFirstLastPageButtons: false,
                            actionsColumnIndex: -100,
                            emptyRowsWhenPaging: false,
                          }}
                          localization={{
                            pagination: {
                              labelRowsSelect: 'Rows',
                              labelRowsPerPage: 'Rows Per Page',
                            },
                          }}
                          title="File Management"
                          columns={[
                            {
                              title:
                                statusToFetchMyCompanyPerformance == 'actualStatus'
                                  ? 'Today'
                                  : new Date().getFullYear() + ' YTD',
                              field: 'ytd',
                              sorting: false,
                              render: (data) => (
                                <InfoPopoverCommentsWrapper
                                  dashboardComments={dashboardComments}
                                  section={data?.metrix}
                                  title="Company Performance invoicing File Management columns"
                                  onCommentUpdate={loadDashboardCommentsDetails}
                                />
                              ),
                            },
                            {
                              title: 'United States',
                              field: 'usa',
                              width: '15%',
                              customSort: (a, b) => customSortHelper(a, b, 'usa'),
                              render: (data) => formatToNumber(data?.usa, null, ''),
                            },
                            {
                              title: 'Mexico',
                              field: 'mexico',
                              width: '15%',
                              customSort: (a, b) => customSortHelper(a, b, 'mexico'),
                              render: (data) => formatToNumber(data?.mexico, null, ''),
                            },
                            {
                              title: 'Chile',
                              field: 'chile',
                              width: '15%',
                              customSort: (a, b) => customSortHelper(a, b, 'chile'),
                              render: (data) => formatToNumber(data?.chile, null, ''),
                            },
                            {
                              title: 'Peru',
                              field: 'peru',
                              width: '15%',
                              customSort: (a, b) => customSortHelper(a, b, 'peru'),
                              render: (data) => formatToNumber(data?.peru, null, ''),
                            },
                          ]}
                          data={fileManagementForCompany || []}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <QbFieldsByCountry
                      financialPerformanceCountryByYear={financialPerformanceCountryByYear}
                      reportArr={summaryInvoiceByCountryArr}
                      reportByCell={summaryInvoiceByCellArr}
                      myCountryInvoiceArray={myCompanyInvoicingPerformanceData}
                      myProfitRevenue={profitRevenueQbObj}
                      dashboardComments={dashboardComments}
                      dashboardSectionText="INVOICING - Accounting"
                      onCommentUpdate={loadDashboardCommentsDetails}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  height={1}
                  mt={0.5}
                >
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Box>
                      <Link color="textPrimary" href="/#/app/dashboard/company">
                        <Typography variant="caption">View all</Typography>
                      </Link>
                    </Box>
                    <Box className={classes.ViewAll}>
                      <ArrowForwardIcon />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} className={classes.innercontent}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h5">Global Giving Causes</Typography>
                  </Grid>
                  <If condition={recentGlobalGivingCauses != null}>
                    <For each="globalGiving" of={recentGlobalGivingCauses || []}>
                      <Grid item xs={12} sm={6} md={4}>
                        <Box className={classes.innercontentWhite} height="100%">
                          <Box
                            display="flex"
                            justifyContent="flex-end"
                            className={classes.GlobalGivingCausesMore}
                          >
                            <If
                              condition={
                                editGlobalCausePermission === true ||
                                deleteGlobalCausePermission === true ||
                                (loggedInUserDetails?.department?.departmentTitle ===
                                  DEPARTMENT_ADMIN &&
                                  loggedInUserDetails?.roleId === 1)
                              }
                            >
                              <EditOptions
                                item={globalGiving}
                                _handleClose={handleClose}
                                handleEditClickOpen={() => {
                                  handleClickOnEditGlobalCause(globalGiving?.id);
                                }}
                                handleClickDelete={() => {
                                  handleClickOnDeleteGlobalCause(globalGiving?.id);
                                }}
                                roleId={loggedInUserDetails?.roleId}
                                departmentId={loggedInUserDetails?.department?.departmentTitle}
                                editPermission={editGlobalCausePermission}
                                deletePermission={deleteGlobalCausePermission}
                              />
                            </If>
                          </Box>

                          <Box display="flex" justifyContent="center">
                            <a
                              href={globalGiving.link}
                              rel="noreferrer"
                              target="_blank"
                              className={classes.GlobalGivingCausesLink}
                            >
                              <img
                                className={classes.GlobalGivingCausesThumb}
                                src={
                                  location.hostname === 'localhost'
                                    ? `//localhost:9001/${globalGiving?.images}`
                                    : `/api/${globalGiving?.images}`
                                }
                                alt="Global Giving Causes"
                              />
                            </a>
                          </Box>
                          <Box display="flex" justifyContent="space-between" my={1}>
                            <Box>
                              <Box>
                                <Typography variant="h4">
                                  {globalGiving?.organizationName}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant="body2">
                                  {globalGiving?.typeOfGlobalCause === '1'
                                    ? 'Vector Global'
                                    : `${globalGiving?.countrydetails?.countryTitle ?? ''} ${
                                        globalGiving?.celldetails?.cellTitle ?? ''
                                      }`}
                                </Typography>
                              </Box>
                            </Box>
                            <Box>
                              {globalGiving?.amount !== null ? (
                                globalGiving.isTypeOfAmountPerYear === '1' ? (
                                  <Typography variant="h5">
                                    {formatToCurrency(globalGiving?.amount)}/year
                                  </Typography>
                                ) : (
                                  <Typography variant="h5">
                                    Total {formatToCurrency(globalGiving?.amount)}
                                  </Typography>
                                )
                              ) : (
                                <Typography variant="h5">N/A</Typography>
                              )}
                            </Box>
                          </Box>
                          <Box>
                            <Typography variant="body1">{globalGiving.description}</Typography>
                          </Box>
                          {globalGiving?.extraLink ? (
                            <Box display="inline-flex">
                              <a
                                href={globalGiving?.extraLink}
                                target={globalGiving?.extraLink ? '_blank' : ''}
                                className={classes.GlobalGivingCausesLinkAR}
                              >
                                Additional Resources
                              </a>
                            </Box>
                          ) : (
                            ''
                          )}
                        </Box>
                      </Grid>
                    </For>
                  </If>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  height={1}
                  mt={0.5}
                >
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Box>
                      <Link color="textPrimary" href="/#/app/global-giving-causes">
                        <Typography variant="caption">View all</Typography>
                      </Link>
                    </Box>
                    <Box className={classes.ViewAll}>
                      <ArrowForwardIcon />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={updateAnnouncements}
          validationSchema={SetAddAnnouncementSchema}
          onSubmit={async (values) => {
            const allValues = values;
            //allValues.id = announcementId;
            allValues.id = updateAnnouncements?.id;
            const result = await addAnnouncement(allValues);
            if (typeof result !== 'undefined') {
              if (result.status) {
                setShowSnackBarMessage('Announcement Updated Successfully');
                setShowSnackBarErr(true);
                setUpdateAnnouncementDialog(false);
                loadDashboardDetails();
              }
            }
          }}
        >
          {({
            errors,
            isSubmitting,
            touched,
            setFieldValue,
            setFieldTouched,
            submitForm,
            resetForm,
          }) => {
            return (
              <Form autoComplete="off">
                <Dialog
                  className={classes.dialogOuterMedium}
                  fullScreen={fullScreen}
                  open={updateAnnouncementDialog}
                  onClose={() => {
                    resetForm();
                    handleClose();
                  }}
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle className={classes.dialogTitle} id="responsive-dialog-title">
                    <Typography variant="h2" noWrap component="span">
                      Update an Announcement
                    </Typography>
                    <IconButton
                      aria-label="close"
                      onClick={() => {
                        resetForm();
                        handleClose();
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Grid container direction="row">
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                              Title*
                            </Box>
                            <FastField
                              as={TextField}
                              name="title"
                              variant="outlined"
                              type="text"
                              error={!!showErrIfTouched('title', errors, touched)}
                              helperText={showErrIfTouched('title', errors, touched)}
                              fullWidth
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                              Description
                            </Box>
                            <Field
                              as={TextField}
                              variant="outlined"
                              multiline
                              rows={4}
                              fullWidth
                              name="description"
                              inputProps={{ maxLength: 300 }}
                              error={!!showErrIfTouched('description', errors, touched)}
                              helperText={showErrIfTouched('description', errors, touched)}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                              Expiration Date*
                            </Box>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <Field
                                inputVariant="outlined"
                                autocomplete="off"
                                as={KeyboardDatePicker}
                                autoOk
                                name="expirationDate"
                                id="outlined-basic-2"
                                variant="outlined"
                                fullWidth
                                minDate={new Date()}
                                format="MM/dd/yyyy"
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                onChange={(val) => {
                                  setFieldValue('expirationDate', filterDate(val));
                                }}
                                onClose={() => {
                                  setTimeout(() => setFieldTouched('expirationDate'), 1000);
                                }}
                                onBlur={() => {
                                  setTimeout(() => setFieldTouched('expirationDate'), 1000);
                                }}
                                error={!!showErrIfTouched('expirationDate', errors, touched)}
                                helperText={showErrIfTouched('expirationDate', errors, touched)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => {
                        submitForm();
                      }}
                      color="primary"
                      variant="contained"
                      autoFocus
                    >
                      Update
                    </Button>
                    {isSubmitting && (
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    )}
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
        <Formik
          initialValues={
            editData?.id
              ? editData
              : {
                  type: null,
                  whatHappened: '',
                  cost: '',
                  doneDifferently: '',
                  learned: '',
                  eventDate: null,
                }
          }
          enableReinitialize
          validationSchema={object().shape({
            type: string().required('Required').nullable(),
            whatHappened: string().max(300, 'Maximum character allowed is 300.').nullable(),
            cost: string().nullable(),
            doneDifferently: string()
              .when('type', {
                is: '2',
                then: string().max(300, 'Maximum character allowed is 300.'),
              })
              .nullable(),
            learned: string()
              .required('Required')
              .max(300, 'Maximum character allowed is 300.')
              .nullable(),
            eventDate: date('Please enter Event date')
              .nullable()
              .typeError('Please enter a valid Event date')
              .min(new Date('1899-12-31'), 'Please enter a valid Event date')
              .required('Event Date is required')
              .test(
                'future-date',
                'Future date is not allowed',
                (value) =>
                  moment()
                    .hour(0)
                    .minute(0)
                    .second(0)
                    .millisecond(0)
                    .diff(moment(value).hour(0).minute(0).second(0).millisecond(0)) > -1,
              ),
          })}
          onSubmit={async (values, { resetForm }) => {
            const data = await saveLearningOpportunity(values);

            if (data?.status) {
              setShowSnackBarMessage('Learning Opportunity Updated Successfully');
              setShowSnackBarErr(true);
              setOpenLearningForm(false);
              loadDashboardDetails();
              resetForm();
              setEditData(null);
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            //isValid,
            setFieldValue,
            setFieldTouched,
            resetForm,
            submitForm,
          }) => {
            return (
              <Form autoComplete="off">
                <Dialog
                  className={clsx(classes.dialogOuterMedium, classes.helperText)}
                  fullScreen={fullScreen}
                  open={openLearningForm}
                  onClose={() => {
                    resetForm();
                    handleClose();
                  }}
                  aria-labelledby="responsive-dialog-title"
                  disableBackdropClick
                >
                  <DialogTitle className={classes.dialogTitle} id="responsive-dialog-title">
                    <Typography variant="h2" noWrap component="span">
                      {' '}
                      {}
                      {values?.id ? `Edit` : `Add`} a Learning Opportunity
                    </Typography>
                    <IconButton
                      aria-label="close"
                      onClick={() => {
                        resetForm();
                        handleClose();
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Grid container direction="row">
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography variant="subtitle1">
                              Which type of Learning Opportunity would you like to add?
                            </Typography>
                          </Grid>
                          <Grid item xs={12} className={classes.RadioStyle}>
                            <FastField as={RadioGroup} name="type">
                              <FormControlLabel
                                value="1"
                                control={<Radio />}
                                label="Accomplishment"
                                checked={values.type === '1'}
                              />
                              <FormControlLabel
                                value="2"
                                control={<Radio />}
                                label="Mistake"
                                checked={values.type === '2'}
                              />
                            </FastField>
                          </Grid>
                          <Grid item xs={12}>
                            <Box m={2} />
                          </Grid>
                        </Grid>
                      </Grid>

                      <If condition={values?.type}>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Typography variant="h2" noWrap component="span">
                                {' '}
                                {}
                                Add {values?.type === '1' ? `an Accomplishment` : `a Mistake`}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Box mb={0.5} display="flex" justifyContent="space-between">
                                <Box>
                                  <Typography variant="subtitle1">What happened?</Typography>
                                </Box>
                                <Box>
                                  <Typography variant="body2">300 character limit</Typography>
                                </Box>
                              </Box>
                              <Field
                                name="whatHappened"
                                placeholder="What happened?"
                                as={TextField}
                                variant="outlined"
                                id="whatHappened"
                                multiline
                                rows={3}
                                fullWidth
                                error={!!showErrIfTouched('whatHappened', errors, touched)}
                                helperText={showErrIfTouched('whatHappened', errors, touched)}
                              />
                            </Grid>

                            <If condition={values.type === '2'}>
                              <Grid item xs={12}>
                                <Box>
                                  <Typography variant="subtitle1">
                                    How much did it cost us?
                                  </Typography>
                                </Box>
                                <Field
                                  as={TextField}
                                  name="cost"
                                  placeholder="How much did it cost us?"
                                  id="cost"
                                  variant="outlined"
                                  component={NumberFormat}
                                  customInput={TextField}
                                  allowNegative={false}
                                  thousandSeparator
                                  decimalSeparator={false}
                                  prefix="$ "
                                  type="text"
                                  value={values.cost}
                                  onBlur={() => {
                                    setFieldTouched('cost');
                                  }}
                                  onValueChange={(val) => {
                                    setFieldValue('cost', val.value);
                                  }}
                                  error={!!showErrIfTouched('cost', errors, touched)}
                                  helperText={showErrIfTouched('cost', errors, touched)}
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <Box mb={0.5} display="flex" justifyContent="space-between">
                                  <Box>
                                    <Typography variant="subtitle1">
                                      What could you have done differently?
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography variant="body2">300 character limit</Typography>
                                  </Box>
                                </Box>
                                <Field
                                  name="doneDifferently"
                                  placeholder="What could you have done differently?"
                                  as={TextField}
                                  variant="outlined"
                                  id="doneDifferently"
                                  multiline
                                  rows={3}
                                  fullWidth
                                  error={!!showErrIfTouched('doneDifferently', errors, touched)}
                                  helperText={showErrIfTouched('doneDifferently', errors, touched)}
                                />
                              </Grid>
                            </If>
                            <Grid item xs={12}>
                              <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                                Event Date*
                              </Box>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <Field
                                  inputVariant="outlined"
                                  autocomplete="off"
                                  as={KeyboardDatePicker}
                                  autoOk
                                  disableFuture
                                  name="eventDate"
                                  id="outlined-basic-2"
                                  variant="outlined"
                                  fullWidth
                                  format="MM/dd/yyyy"
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                  onChange={(val) => {
                                    setFieldValue('eventDate', filterDate(val));
                                  }}
                                  onClose={() => {
                                    setTimeout(() => setFieldTouched('eventDate'), 1000);
                                  }}
                                  onBlur={() => {
                                    setTimeout(() => setFieldTouched('eventDate'), 1000);
                                  }}
                                  error={!!showErrIfTouched('eventDate', errors, touched)}
                                  helperText={showErrIfTouched('eventDate', errors, touched)}
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12}>
                              <Box mb={0.5} display="flex" justifyContent="space-between">
                                <Box>
                                  <Typography variant="subtitle1">What did you learn?*</Typography>
                                </Box>
                                <Box>
                                  <Typography variant="body2">300 character limit</Typography>
                                </Box>
                              </Box>
                              <Field
                                as={TextField}
                                name="learned"
                                placeholder="What did you learn?"
                                variant="outlined"
                                id="learned"
                                multiline
                                rows={3}
                                fullWidth
                                error={!!showErrIfTouched('learned', errors, touched)}
                                helperText={showErrIfTouched('learned', errors, touched)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </If>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    <div className={classes.wrapper}>
                      <Button
                        onClick={() => submitForm()}
                        color="primary"
                        variant="contained"
                        //disabled={isSubmitting || !isValid || Object.keys(touched).length === 0}
                      >
                        Update
                      </Button>
                      {isSubmitting && (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      )}
                    </div>
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
        <Formik
          enableReinitialize
          initialValues={{
            organizationname: editCauseDetails?.organizationName,
            description: editCauseDetails?.description,
            images: editCauseDetails?.file,
            countryid: editCauseDetails?.countryId,
            cellid: editCauseDetails?.cellId,
            amount: editCauseDetails?.amount,
            typeofglobalcause: editCauseDetails?.typeOfGlobalCause,
            isTypeOfAmountPerYear: editCauseDetails?.isTypeOfAmountPerYear,
            imagelink: editCauseDetails?.link,
            extraLink: editCauseDetails?.extraLink,
          }}
          validationSchema={SetGlobalGivingCausesSchema}
          onSubmit={async (values) => {
            const formData = new FormData();
            formData.append('id', editCauseDetails?.id);
            formData.append('organizationname', values?.organizationname);
            formData.append('description', values?.description);
            formData.append('typeofglobalcause', values?.typeofglobalcause);
            formData.append('isTypeOfAmountPerYear', values?.isTypeOfAmountPerYear);
            formData.append('amount', values?.amount ? values?.amount : '');
            formData.append('countryid', values?.countryid == null ? '' : values?.countryid);
            formData.append('cellid', values?.cellid == null ? '' : values?.cellid);
            formData.append('imagelink', values?.imagelink);
            formData.append('extraLink', values?.extraLink ? values?.extraLink : '');
            formData.append('images', values?.images[0]);
            formData.append('oldImageUrl', editCauseDetails.images);
            const result = await addGlobalGivingCause(formData);
            if (typeof result !== 'undefined') {
              if (result.status) {
                setShowSnackBarMessage('Global Giving Cause Updated Successfully');
                setShowSnackBarErr(true);
                setOpenEditGlobalCauseForm(false);
                loadDashboardDetails();
              }
            }
          }}
        >
          {({
            errors,
            isSubmitting,
            touched,
            setFieldValue,
            setFieldTouched,
            submitForm,
            values,
            resetForm,
          }) => {
            return (
              <Dialog
                className={classes.dialogOuterMedium}
                fullScreen={fullScreen}
                open={openEditGlobalCauseForm}
                onClose={() => {
                  resetForm();
                  handleClose();
                }}
                aria-labelledby="responsive-dialog-title"
              >
                <DialogTitle className={classes.dialogTitle} id="responsive-dialog-title">
                  <Typography variant="h2" noWrap component="span">
                    Update Global Giving Cause
                  </Typography>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      resetForm();
                      handleClose();
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Grid container direction="row">
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                            Organization Name*
                          </Box>
                          <FastField
                            as={TextField}
                            name="organizationname"
                            variant="outlined"
                            type="text"
                            error={!!showErrIfTouched('organizationname', errors, touched)}
                            helperText={showErrIfTouched('organizationname', errors, touched)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Typography variant="subtitle1">
                                Who participated in the project or made the donation?*
                              </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.RadioStyle}>
                              <FastField as={RadioGroup} name="typeofglobalcause">
                                <FormControlLabel
                                  value="1"
                                  control={<Radio />}
                                  label="VectorGlobal"
                                  checked={values.typeofglobalcause === '1'}
                                />
                                <FormControlLabel
                                  value="0"
                                  control={<Radio />}
                                  label="Cell"
                                  checked={values.typeofglobalcause === '0'}
                                />
                              </FastField>
                            </Grid>
                            <Grid item xs={12}>
                              <Box m={2} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <If condition={values.typeofglobalcause === '0'}>
                          <Grid item xs={12}>
                            <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                              Select Country*
                            </Box>
                            <Autocomplete
                              options={globalGivingCountryList}
                              getOptionLabel={(option) => option?.countryTitle}
                              getOptionSelected={(option, value) => option?.id === value?.id}
                              value={globalGivingCountryList.find(
                                (d) => d?.id === values.countryid,
                              )}
                              onChange={(e, val) => {
                                setFieldValue('countryid', val?.id || '');
                                setFieldTouched('countryid');
                                loadCells(val.id);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} name="countryid" variant="outlined" />
                              )}
                              popupIcon={<ExpandMoreIcon />}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                              Select Cell*
                            </Box>
                            <Autocomplete
                              options={cellList}
                              getOptionLabel={(option) => option?.cellTitle}
                              getOptionSelected={(option, value) => option?.id === value?.id}
                              value={cellList.find((d) => d?.id === values.cellid)}
                              onChange={(e, value) => {
                                setFieldValue('cellid', value?.id || '');
                                setFieldTouched('cellid');
                              }}
                              renderInput={(params) => (
                                <TextField {...params} name="cellid" variant="outlined" />
                              )}
                              popupIcon={<ExpandMoreIcon />}
                            />
                          </Grid>
                        </If>
                        <Grid item xs={12}>
                          <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                            Date and description of project or donation*
                          </Box>
                          <Field
                            as={TextField}
                            variant="outlined"
                            multiline
                            rows={4}
                            fullWidth
                            name="description"
                            inputProps={{ maxLength: 300 }}
                            error={!!showErrIfTouched('description', errors, touched)}
                            helperText={showErrIfTouched('description', errors, touched)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                            Main image to be displayed for team to see*
                          </Box>
                          <Box className={classes.FileUploadStyle}>
                            <Field
                              full
                              type="file"
                              name="images"
                              component={Dropzone}
                              errorMessage="Only Images are allowed."
                              accept=".PNG, .jpg, .JPG, .jpeg, .JPEG"
                              id="file"
                              maxSize={20 * 1024 * 1024}
                              multiple={false}
                              maxSizeError="Size exceeds 20MB, please select an alternate file"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Typography variant="subtitle1">
                                Is Amount Total per year or Total?
                              </Typography>
                            </Grid>
                            <Grid item xs={12} className={classes.RadioStyle}>
                              <FastField as={RadioGroup} name="isTypeOfAmountPerYear">
                                <FormControlLabel
                                  value="1"
                                  control={<Radio />}
                                  label="Total per Year"
                                  checked={values.isTypeOfAmountPerYear === '1'}
                                />
                                <FormControlLabel
                                  value="0"
                                  control={<Radio />}
                                  label="Total"
                                  checked={values.isTypeOfAmountPerYear === '0'}
                                />
                              </FastField>
                            </Grid>
                            <Grid item xs={12}>
                              <Box m={2} />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                            Amount
                          </Box>
                          <FastField
                            as={TextField}
                            name="amount"
                            variant="outlined"
                            type="text"
                            prefix={'$ '}
                            error={!!showErrIfTouched('amount', errors, touched)}
                            helperText={showErrIfTouched('amount', errors, touched)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                            Additional resource link*
                          </Box>
                          <FastField
                            as={TextField}
                            name="imagelink"
                            variant="outlined"
                            type="text"
                            error={!!showErrIfTouched('imagelink', errors, touched)}
                            helperText={showErrIfTouched('imagelink', errors, touched)}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box mb={0.5} fontSize="h6.fontSize" fontWeight="bold">
                            Link to Additional photos or videos
                          </Box>
                          <FastField
                            as={TextField}
                            name="extraLink"
                            variant="outlined"
                            type="text"
                            error={!!showErrIfTouched('extraLink', errors, touched)}
                            helperText={showErrIfTouched('extraLink', errors, touched)}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    autoFocus
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Update
                  </Button>
                  {isSubmitting && (
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  )}
                </DialogActions>
              </Dialog>
            );
          }}
        </Formik>
        <DeleteOption
          message={DELETE_ANNOUCEMENT_WARNING}
          openDeleteDialog={openDeleteDialog}
          fullScreen={fullScreen}
          onClickYes={() => {
            deleteSelectedAnnouncement();
          }}
          handleClose={() => {
            handleClose();
          }}
        />
        <DeleteOption
          message={DELETE_LEARNING_OPP_WARNING}
          openDeleteDialog={openDelete}
          fullScreen={fullScreen}
          onClickYes={() => {
            handleOnDeleteClick();
          }}
          handleClose={() => {
            handleClose();
          }}
        />
        <DeleteOption
          message={DELETE_GLOBAL_GIVING_CAUSE}
          openDeleteDialog={openGlobalCauseDelete}
          fullScreen={fullScreen}
          onClickYes={() => {
            deleteGlobalGivingCause();
          }}
          handleClose={() => {
            handleClose();
          }}
        />
      </Grid>
      <WelcomeModal userDetails={loggedInUserDetails} />
      <Grid item xs={12}>
        <Snackbar open={showSnackBarErr} autoHideDuration={4000} onClose={handleSnackBarClose}>
          <Alert elevation={6} variant="filled" onClose={handleSnackBarClose} severity="success">
            {showSnackBarMessage}
          </Alert>
        </Snackbar>
      </Grid>
    </>
  );
});

export default SummaryTab;
